import {match} from 'ts-pattern';

import {Nullish} from 'shared/web';

/**
 * Outlook bodies routinely carry Teams boilerplate (join links, meeting id, passcode) that runs to
 * hundreds of characters. The popup is a hover glance, so anything past this is cut off rather
 * than pushed off the screen.
 */
export const MAX_OUTLOOK_EVENT_DESCRIPTION_LENGTH = 280;

const ELLIPSIS = '…';

export function truncateOutlookEventDescription(description: string | Nullish) {
  const trimmed = description?.trim() ?? '';

  return match(trimmed)
    .with('', () => null)
    .when(
      (text) => text.length <= MAX_OUTLOOK_EVENT_DESCRIPTION_LENGTH,
      (text) => text
    )
    .otherwise(
      (text) => `${text.slice(0, MAX_OUTLOOK_EVENT_DESCRIPTION_LENGTH).trimEnd()}${ELLIPSIS}`
    );
}
